import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { App } from "./App";
import { Login } from "./pages/Login";
import { AcceptInvite } from "./pages/AcceptInvite";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { Dashboard } from "./pages/Dashboard";
import { Workbench } from "./pages/Workbench";
import { ReviewPage } from "./pages/Review";
import { DiscoveredPage } from "./pages/Discovered";
import { PlanPage } from "./pages/Plan";
import { Sites } from "./pages/Sites";
import { Installations } from "./pages/Installations";
import { SuperAdmin } from "./pages/SuperAdmin";
import { Demos } from "./pages/Demos";
import { DemoDetail } from "./pages/DemoDetail";
import "./admin.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route element={<App />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/workbench" element={<Workbench />} />
          <Route path="/workbench/:id/review" element={<ReviewPage />} />
          <Route path="/plan" element={<PlanPage />} />
          <Route path="/discovered" element={<DiscoveredPage />} />
          <Route path="/sites" element={<Sites />} />
          <Route path="/installations" element={<Installations />} />
          <Route path="/superadmin" element={<SuperAdmin />} />
          <Route path="/demos" element={<Demos />} />
          <Route path="/demos/:id" element={<DemoDetail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
